<template>
    <div class="multipleMediaField">
        <draggable
            :list="items"
            class="columns flex flex-wrap"
            @change="orderChanged"
        >
            <div
                v-for="(item, index) in items"
                :key="item.id"
                class="column"
            >
                <div class="inner relative">
                    <button
                        type="button"
                        class="removeButton"
                        @click="removeItem(index)"
                    >
                        <svg svg-inline="" class="removeIcon" @click="$emit('removeItem')" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                    <MediaField
                        :type="type"
                        :initial-media="item"
                        :disabled-items="itemIds"
                        @changed="media => itemChanged(item, media)"
                    />
                </div>
            </div>
        </draggable>
        <div class="bottom text-right">
            <AppButton
                :small="true"
                label="Add media"
                @click="addMedia"
            />
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import MediaField from './MediaField.vue';
import AppButton from '../ui/AppButton.vue';

export default {
    components: {
        draggable,
        MediaField,
        AppButton,
    },
    props: {
        initialItems: {
            type: Array,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        items: [],
    }),
    computed: {
        itemIds() {
            return this.items.map(item => item.id);
        },
    },
    created() {
        if (this.initialItems) {
            this.items = this.initialItems;
        }
    },
    methods: {
        orderChanged() {
            this.emitChanges();
        },
        itemChanged(oldItem, newItem) {
            const index = this.items.indexOf(oldItem);
            this.items[index] = newItem;

            this.emitChanges();
        },
        removeItem(index) {
            if (this.items[index]) {
                this.items.splice(index, 1);
            }

            this.emitChanges();
        },
        addMedia() {
            this.items.push({ id: Date.now() });
        },
        emitChanges() {
            const items = this.items.filter(item => item.source);
            this.$emit('changed', items);
        },
    },
};
</script>

<style lang="postcss" scoped>
.multipleMediaField {
    padding: 25px;
    border: 1px solid var(--borderColor);
    border-radius: var(--borderRadius);
    @media (--laptop) {
        padding: 15px;
    }
}
.multipleMediaField .mediaField {
    width: 100%;
}
.columns {
    margin: -15px;
    margin-bottom: 15px;
    @media (--laptop) {
        margin: -10px;
        margin-bottom: 10px;
    }
}
.column {
    padding: 15px;
    width: 12.5%;
    @media (max-width: 2200px) {
        width: 16.6666666667%;
    }
    @media (max-width: 1800px) {
        width: 20%;
    }
    @media (--laptop) {
        width: 25%;
        padding: 10px;
    }
}
.column.sortable-ghost {
    opacity: 0.5;
}
.removeButton {
    position: absolute;
    right: -10px;
    top: -10px;
    width: 26px;
    height: 26px;
    background-color: var(--grey600);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    z-index: 1;
    @media (--laptop) {
        right: -8px;
        top: -8px;
        width: 22px;
        height: 22px;
    }
    &:hover {
        background-color: var(--danger);
    }
}
.removeIcon {
    height: 16px;
    width: 16px;
}
</style>
